import { Box, Image, Text } from '@mantine/core';
import Logo from "../../assets/img/brand.png"
import React from 'react';

function NavbarHeader() {
    return (
        <Box style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
        }}>
            <Image h="32px" w="32px" src={Logo} />
            <Text className="unify-nav-header-title" flex={1}>Unify</Text>
        </Box>
    )
}

export default NavbarHeader;